
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/page/[page]",
      function () {
        return require("private-next-pages/companies/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/page/[page]"])
      });
    }
  